import { render, staticRenderFns } from "./newsservice.vue?vue&type=template&id=4b54718b&scoped=true&"
import script from "./newsservice.vue?vue&type=script&lang=js&"
export * from "./newsservice.vue?vue&type=script&lang=js&"
import style0 from "./newsservice.vue?vue&type=style&index=0&id=4b54718b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b54718b",
  null
  
)

export default component.exports